import { Box, Button, Col, Row, Text } from '@opendoor/bricks-next';
import { EntryComponent } from 'cms/entries/entries';
import { Desc } from 'components/landing-pages-v2/shared/Typography';
import { ILpComponentContactButton, ILpComponentContactSection } from 'declarations/contentful';

import Grid from './Grid';

const RenderContactButton = (entry: ILpComponentContactButton) => {
  const { fields } = entry;
  const analyticsName = `cosmos-landing-page-contact-button-${fields?.analyticsId}`;
  return (
    <Button
      key={analyticsName}
      variant="primary"
      size="small"
      label={fields.text}
      analyticsName={analyticsName}
      aria-label={fields.text}
      onPress={() => {
        window.location.href = fields.href;
      }}
      $platform-web={{
        width: 'fit-content',
      }}
    />
  );
};

const RenderContactSection = (entry: ILpComponentContactSection) => {
  const { fields } = entry;
  const analyticsName = `cosmos-landing-page-contact-section-${fields?.analyticsId}`;

  return (
    <Grid>
      <Col
        analyticsName={analyticsName}
        trackImpression
        gap="$16x"
        py="$40x"
        $platform-web={{ gridColumn: 'span 12 / span 12' }}
        $largerThanMD={{ alignItems: 'center' }}
      >
        <Col gap="$10x">
          <Box
            $largerThanMD={{ flexDirection: 'row', justifyContent: 'center', gap: '$6x' }}
            gap="$4x"
            flexDirection="column"
          >
            <Text
              tag="h2"
              typography="$headerSmall"
              $largerThanMD={{ typography: '$headerMedium' }}
            >
              {fields?.title}
            </Text>
            <Text
              tag="h2"
              typography="$headerSmall"
              $largerThanMD={{ typography: '$headerMedium' }}
            >
              {fields?.subtitle}
            </Text>
          </Box>
          <Desc $largerThanMD={{ fontSize: 24 }}>{fields?.description}</Desc>
        </Col>
        <Row gap="$4x" alignItems="flex-start" $largerThanLG={{ gap: '$10x' }} flexWrap="wrap">
          {entry.fields.contactButtons?.map((contactButton: ILpComponentContactButton) => {
            return RenderContactButton(contactButton);
          })}
        </Row>
      </Col>
    </Grid>
  );
};

const ContactSection: EntryComponent<ILpComponentContactSection> = {
  render: RenderContactSection,
};

export default ContactSection;
